module.exports = __webpack_public_path__ + "static/media/Aegislash_gaussian2.ceec4ae0.png";